var render, staticRenderFns
import script from "./FileStorage.vue?vue&type=script&lang=js&"
export * from "./FileStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eafa990",
  null
  
)

export default component.exports